import {SERVICE_ENDPOINT, STATUS_GROUPS} from "../const";
import {gatewayInstance} from "../axiosInstance";

export const masterShiftSearch = async (search) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}//shift/shift-namestartswith`,
            search,
        );
        console.log("shift-namestartswith", response)
        return response.data.map((item) => ({
            key: item.id,
            title: item.text,
            value: item.value,
        }));
    } catch (e) {
        console.error(e);
    }
};

export const addShiftAssignment = async (data) => {
    try {
        console.log("Shift Assignment data",data);
        return await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-assignment/shift-assignment-create`,
            data,
        );
    } catch (e) {
        console.error(e);
    }
};

export const updateShiftAssignment = async (data) => {
    try {
        console.log("Shift Assignment data update",data);
        return await gatewayInstance.put(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-assignment/shift-assignment-update`,
            data,
        );
    } catch (e) {
        console.error(e);
    }
};

export const searchAssignmentData = async (data) => {
    try {
        console.log(`searchAssignmentData`, data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-assignment/shift-assignment-search`,
            data,
        );
        console.log(`shift serch res`, response);
        return response.data;
        return null;
    } catch (e) {
        console.error(e);
    }
};

export const getShiftAssignmentById = async (id) =>{
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-assignment/shift-assignment/${id}`,
        );
        console.log('shift-assignment', response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
}

export const findUserGroupById = async (id) =>{
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-assignment/shift-assignment-users/${id}`,
        );
        console.log('shift-assignment', response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
}

export const findStkGroupById = async (id) =>{
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift-assignment/shift-assignment-stks/${id}`,
        );

        return response.data;
    } catch (e) {
        console.error(e);
    }
}

export const findAll = async () =>{
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/shift/shift-all`,
        );

        return response.data.map((item) => ({
            key: item.id,
            title: item.text,
            value: item.value,
        }));
    } catch (e) {
        console.error(e);
    }
}


